var React = require('react');

function MinusInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"343.03","cy":"343.03","r":"343.03","style":{"fill":"#1d5377"},"key":0}),React.createElement("line",{"x1":"169.05","y1":"343.03","x2":"517.01","y2":"343.03","style":{"fill":"none","stroke":"#fff","strokeMiterlimit":"10","strokeWidth":"45px"},"key":1})]);
}

MinusInline.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 686.05 686.05"};

module.exports = MinusInline;

MinusInline.default = MinusInline;
